export default "__VITE_ASSET__xFXjgyR$__"